/*
 * @Date: 2025-04-08 15:11:55
 * @LastEditors: guantingting
 * @LastEditTime: 2025-04-29 17:41:31
 */
export default [
  {
    path: '/rent/v2/login',
    name: 'login',
    component: () => import('@/pages/login/login.vue'),
    meta: { title: '登录', requireAuth: true },
  },
  {
    path: '/rent/v2/staff-login',
    name: 'staffLogin',
    component: () => import('@/pages/login/staffLogin.vue'),
    meta: { title: '登录', requireAuth: true },
  },
  {
    path: '/rent/v2/thirdAppLogin',
    name: 'thirdAppLogin',
    component: () => import('@/pages/login/thirdAppLogin.vue'),
    meta: { title: '验证预定人', requireAuth: true },
  },
]



// WEBPACK FOOTER //
// ./src/pages/login/login.js